import {
    fk,
    many,
    attr,
    oneToOne,
} from 'redux-orm';
import singleLabel from '../defaults/singleLabel';
import BaseModel from './BaseModel';
import { OBJECT_TYPE_ROW } from '%paysera_seat_selection/js/seatSelection/config/constants';

class Row extends BaseModel {
    static modelName = 'Row';

    static fields = {
        ...BaseModel.fields,
        labelLeft: attr({ getDefault: () => singleLabel }),
        labelRight: attr({ getDefault: () => singleLabel }),
        sector: fk('Sector'),
        configuration: oneToOne('Configuration'),
        seats: many('Seat'),
        objectType: attr({ getDefault: () => OBJECT_TYPE_ROW }),
        enabled: attr({ getDefault: () => true }),
    };
}

export default Row;
